<template>
  <div>
    <PageHeader title="Add Labor" />

    <div class="shadow p-5 mt-2 mb-5 bg-white rounded">
      <LaborForm
        :model="labor"
        :save-function="createLabor"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import PageHeader from '@/components/app/AppPageHeader.vue'
import { useHead } from '@unhead/vue'
import { Labor } from '@/models/labor'
import LaborForm from '../components/LaborForm.vue'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import LaborService from '@/services/LaborService'
import { useRouter } from 'vue-router'
import { useNotification } from '@kyvg/vue3-notification'

useHead({ title: 'Add Labor' })

const laborService = new LaborService()
const labor = ref(new Labor())
const { notify } = useNotification()
const $router = useRouter()
const queryClient = useQueryClient()

const { mutateAsync: createLabor } = useMutation({
  mutationFn: (labor: Labor) => laborService.create(labor),
  onSuccess: (createdLabor: Labor) => {
    queryClient.setQueryData(['labor', createdLabor.id], createdLabor)
    queryClient.invalidateQueries({ queryKey: ['labors'] })
    notify({
      type: 'success',
      title: 'Labor created',
      text: 'Labor created successfully'
    })
    $router.push({ name: 'ListLabor' })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to create the labor'
    })
  }
})
</script>
